import script from "./ViewClassStyleBinding.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewClassStyleBinding.vue?vue&type=script&setup=true&lang=js"

import "./ViewClassStyleBinding.vue?vue&type=style&index=0&id=50f4f709&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50f4f709"]])

export default __exports__